import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultEventContextAssets = {
    failedToLoadDataIconName: 'generic-error-message',
    failedToLoadDataRetryButtonIconName: 'arrow-clockwise'
};
export const eventContextAssetsValidator = Validator.object({
    failedToLoadDataIconName: nonEmptyStringValidator,
    failedToLoadDataRetryButtonIconName: nonEmptyStringValidator
});
